function checkLayoutExist(props) {
  const { name, value, isLoggedin, pageName } = props
  switch (name) {
    case 'ProductCollection':
      return pageName === 'HOME' ? value?.collection?.count > 0 : true
    case 'CategoryCollection':
    case 'BrandCollection':
    case 'BlogCollection':
    case 'SellerCollection':
      return value?.collection?.length > 0
    case 'ImageSlideShow':
    case 'ImageCollection':
      return value?.images?.length > 0
    case 'Image':
    case 'ImageWithText':
    case 'ImageWithTextHorizontal':
    case 'ImageTextButtonHorizontal':
    case 'ImageTextButtonVertical':
      return value?.imageUrl
    case 'Accordion':
    case 'AccordionWithSubText':
      return value?.questions?.length > 0
    case 'RichText':
      return value?.description
    case 'VideoCardCarousel':
      return value?.videoCards?.length > 0
    case 'Testimonial':
      return value?.slides?.length > 0
    case 'Promotions':
      return isLoggedin
    case 'RecentlyBoughtProducts':
      return isLoggedin
    default:
      return true
  }
}
export default checkLayoutExist
